import React, { useEffect, useState } from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

import './styles.css'

import CheckCircle from 'components/Icon/CheckCircle';
import Exclamation from 'components/Icon/Exclamation';
import Help from 'components/Icon/Help';
import Information from 'components/Icon/Information';
import XCircle from 'components/Icon/XCircle';

export default function Toast({ children, title, type, onClose }) {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) {
        setTimeout(() => onClose(), 1000);
      }
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  let Icon;
  const css = classNames('Toast z-50 flex absolute bg-page rounded border-t-4 border-primary shadow-sm p-4 cursor-pointer', {
    'movein': visible,
    'moveout': !visible,
  });

  switch (type) {
    case 'error':
      Icon = XCircle;
      break;
    case 'warning':
      Icon = Exclamation;
      break;
    case 'help':
      Icon = Help;
      break;
    case 'success':
      Icon = CheckCircle;
      break;
    case 'info':
    default:
      Icon = Information;
  }

  return (
    <div
      role="button"
      onClick={onClose}
      className={css}
    >
      <Icon width={45} height={45} className="block text-default fill-current align-middle" />
      <div className="flex-1 pl-4 flex items-center">
        <p className="text-default">
          { title && <strong className="leading-tight font-sans text-default block">{title}</strong> }
          {children}
        </p>
      </div>
    </div>
  );
}

Toast.propTypes = {
  title: string,
  type: oneOf(['success', 'info', 'warning', 'error', 'help']),
}

Toast.defaultProps = {
  type: 'info',
}
